/** Date format for calendar day keys (e.g. react-native-calendars, API). */
export const CALENDAR_DAY_FORMAT = 'yyyy-MM-dd';
/** Display format for calendar month headers. */
export const CALENDAR_MONTH_FORMAT_DISPLAY = 'MMMM yyyy';
